import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPreviewStatusByToken } from "../../api/api";
import { storePreviewToken, setPreviewBlockedMessage, withPreviewToken } from "../../helpers/preview";
import "../../pages/success/success-minimal.css";

const PreviewEntry = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    if (!token) {
      setError("Vista previa no disponible");
      return;
    }
    (async () => {
      try {
        await getPreviewStatusByToken(token);
        if (!active) return;
        storePreviewToken(token);
        const search = withPreviewToken("", token);
        navigate({ pathname: "/event", search }, { replace: true });
      } catch (err) {
        if (!active) return;
        const message = err?.response?.data?.message || "Vista previa no disponible";
        setError(message);
        setPreviewBlockedMessage(message);
      }
    })();
    return () => {
      active = false;
    };
  }, [token, navigate]);

  if (!error) {
    return (
      <div className="success-minimal">
        <div className="success-minimal-card">
          <h2 className="success-minimal-title">Validando vista previa</h2>
          <p className="success-minimal-subtext">Un momento por favor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="success-minimal">
      <div className="success-minimal-card">
        <h2 className="success-minimal-title">Vista previa no disponible</h2>
        <p className="success-minimal-subtext">{error}</p>
      </div>
    </div>
  );
};

export default PreviewEntry;
